import './modules/register-service-worker';
import '@ryangjchandler/alpine-clipboard';
import 'alpinejs';

// Admin styles / scripts on when needed
if (document.body.classList.contains('is-admin')) {
  import('./modules/admin');
}

// Controllers (Stimulusjs)
if (document.querySelector('[data-controller]:not(.stock-chart)')) {
  import('./modules/controllers');
}

// Swiper (slider)
if (document.querySelector('.swiper-container')) {
  import('./modules/swiper');
}

// Cookie consent
if (document.querySelector('html[lang="zh"]')) {
  import('./modules/cookie-popup-zh.js');
} else {
  import('./modules/cookie-popup.js');
}

// Anchors
if (document.querySelector('.js-app-design-system-anchors')) {
  import('./modules/design-system/anchors')
}

// Search
if (document.querySelector('.js-ds-search')) {
  import('./modules/design-system/dssearch')
}

// Navigation
if (document.querySelector('.app-design-system__navigation')) {
  import('./modules/design-system/navigation');
}

// Log
if (document.querySelector('.app-design-system__table > table')) {
  import('./modules/design-system/log');
}

if (document.querySelector('code[class^="language"]')) {
  import('./modules/highlight');
}
